<template>
  <div class="table table-bg">
    <div class="table-header center">
      <div class="table-tlt center-left">
        <h2>냉장고 등록</h2>
      </div>
      <div class="table-btn center-right">
        <div>
          <button class="btn btn-140" @click="cancelUpdate">냉장고 리스트</button>
        </div>
      </div>
    </div>
    <div class="table-desc">
      <div class="table-content">
        <table>
          <tr>
            <td class="header">냉장고 ID</td>
            <!-- TODO <td><input type="input" v-model="device.deviceAlias" tabindex="1"/></td> -->
            <td>-자동생성-</td>
          </tr>
          <tr>
            <td class="header">장소</td>
            <td><input type="input" v-model="device.place" tabindex="3"/></td>
          </tr>
          <tr>
            <td class="header">설치 날짜</td>
            <td><input type="input" v-model="device.setupAt" tabindex="5"/></td>
          </tr>
          <tr>
            <td class="header">IP</td>
            <td><input type="input" v-model="device.ip" tabindex="7"/></td>
          </tr>
          <tr>
            <td class="header">사업자 회사 <font style="color:red;">*</font></td>
            <!--
            <td>
              <select v-model="device.companyID" @change="selectCompany(device.companyID, 1)" tabindex="9">
                <option v-for="item in companyList" :key="item.companyID" :value="item.companyID">
                  {{ item.companyName }}
                </option>
              </select>
            </td>
            -->
            <td>{{ company.name }}</td>
          </tr>
          <tr>
            <td class="header">사업자 부서 <font style="color:red;">*</font></td>
            <td>
              <select v-model="device.divisionID" @change="selectDivision(device.divisionID, 1)" tabindex="11">
                <option v-for="item in divisionList"
                  :key="item.divisionID"
                  :value="item.divisionID">
                  {{ item.divisionName }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="header">사업자 담당자</td>
            <td>
              <select v-model="device.operatorUID" tabindex="13">
                <option v-for="item in userList" :key="item.uID" :value="item.uID">
                  {{ item.name }}
                </option>
              </select>
            </td>
          </tr>
        </table>
        <div class="vertical-line"></div>
        <table>
          <tr>
            <td class="header">냉장고 이름 <font style="color:red;">*</font></td>
            <td><input type="input" v-model="device.deviceName" tabindex="2"/></td>
          </tr>
          <tr>
            <td class="header">주소</td>
            <td><input type="input" v-model="device.address" tabindex="4"/></td>
          </tr>
          <tr>
            <td class="header">제조 날짜</td>
            <td><input type="input" v-model="device.manufactureAt" tabindex="6"/></td>
          </tr>
          <tr>
            <td class="header">Port</td>
            <td><input type="input" v-model="device.port" tabindex="8"/></td>
          </tr>
          <tr>
            <td class="header">운영자 회사</td>
            <td>
              <select v-model="device.deviceCompanyID" @change="selectCompany(device.deviceCompanyID, 2)" tabindex="10">
                <option v-for="item in operatorCompanyList" :key="item.companyID" :value="item.companyID">
                  {{ item.companyName }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="header">사업자 부서</td>
            <td>
              <select v-model="device.deviceDivisionID" @change="selectDivision(device.deviceDivisionID, 2)" tabindex="12">
                <option v-for="item in operatorDivisionList"
                  :key="item.divisionID"
                  :value="item.divisionID">
                  {{ item.divisionName }}
                </option>
              </select>
            </td>
          </tr>
          <tr>
            <td class="header">운영자 담당자</td>
            <td>
              <select v-model="device.deviceOperatorUID" tabindex="14">
                <option v-for="item in operatorUserList" :key="item.uID" :value="item.uID">
                  {{ item.name }}
                </option>
              </select>
            </td>
          </tr>
        </table>
      </div>
      <div class="table-btn center">
        <button class="btn btn-140 btn-blue-line" @click="excuteUpdate">
          <span v-if="!processing" class="process">등록</span>
          <ButtonLoading v-else></ButtonLoading>
        </button>
        <button
          class="btn btn-right"
          @click="cancelUpdate"
        >취소</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-alert */
/* eslint-disable no-console */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */

import Configuration from '@/js/Configuration';
import ButtonLoading from '@/components/include/ButtonLoading';

export default {
  props: [
    'company',
  ],
  components: {
    ButtonLoading,
  },
  data: () => ({
    device: {
      deviceID: null,
      deviceName: null,
      deviceAlias: null,
      address: null,
      place: null,
      manufactureAt: new Date().toISOString(),
      setupAt: new Date().toISOString(),
      ip: null,
      port: null,
      companyID: null,
      divisionID: null,
      operatorUID: null,
      deviceCompanyID: null,
      deviceDivisionID: null,
      deviceOperatorUID: null,
    },
    companyList: [],
    divisionList: [],
    userList: [],
    operatorCompanyList: [],
    operatorDivisionList: [],
    operatorUserList: [],
    operatorCompanyID: null,
    operatorDivisionID: null,
    processing: false,
  }),
  created() {
    this.fetchCompanyList(1);
    if (this.company) {
      this.device.companyID = this.company.id;
      this.selectCompany(this.company.id, 1);
    }
    this.fetchCompanyList(2);
  },
  methods: {
    async fetchCompanyList(type) {
      try {
        const listURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/list?page=1&limit=500`;

        const list = await this.$http.get(listURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (list.status !== 200) {
          throw new Error(`Response status is "${list.status}"`);
        }
        if (list.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${list.data.resultCode}"`);
        }

        const companyList = [];
        for (let i = 0; i < list.data.companies.length; i++) {
          const p = list.data.companies[i];
          if (type === 1 && p.scope === 3 || type === 2 && p.scope === 4 && this.device.companyID === p.parentCompanyID) {
            companyList.push(p);
          }
        }
        if (type === 1) {
          this.companyList = companyList;
        } else {
          this.operatorCompanyList = companyList;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async selectCompany(companyID, type) {
      try {
        const getURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/company/${companyID}?withDivisions=true`;

        const result = await this.$http.get(getURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });

        if (result.status !== 200) {
          throw new Error(`Response status is "${result.status}"`);
        }
        if (result.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${result.data.resultCode}"`);
        }

        if (type === 1) {
          this.divisionList = result.data.company.divisions;
        } else {
          this.operatorDivisionList = result.data.company.divisions;
        }
      } catch (e) {
        console.error(e);
      }
    },
    async selectDivision(divisionID, type) {
      try {
        const getURL = `${Configuration.value(
          'CACCOUNT_ADDRESS',
        )}/api/v1/caccount/division/${divisionID}?withUsers=true`;

        const result = await this.$http.get(getURL, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
          },
        });
        if (result.status !== 200) {
          throw new Error(`Response status is "${result.status}"`);
        }
        if (result.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${result.data.resultCode}"`);
        }

        if (type === 1) {
          this.userList = [];
          for (let i = 0; i < result.data.division.users.length; i++) {
            if (result.data.division.users[i].role === 2 || result.data.division.users[i].role === 3) {
              this.userList.push(result.data.division.users[i]);
            }
          }
        } else {
          this.operatorUserList = [];
          for (let i = 0; i < result.data.division.users.length; i++) {
            if (result.data.division.users[i].role === 2 || result.data.division.users[i].role === 3) {
              this.operatorUserList.push(result.data.division.users[i]);
            }
          }
        }
      } catch (e) {
        console.error(e);
      }
    },
    async excuteUpdate() {
      try {
        this.processing = true;
        const url = `${Configuration.value(
          'CPRODUCT_ADDRESS',
        )}/api/v1/cproduct/device`;


        const param = this.device;
        param.manufactureAt = new Date(this.$moment(param.manufactureAt).format()).toISOString();
        param.setupAt = new Date(this.$moment(param.setupAt).format()).toISOString();
        param.port = parseInt(this.device.port, 10);
        const createResult = await this.$http.post(url,
          param,
          {
            headers: {
              Authorization: `Bearer ${this.$cookie.get('accessToken')}`,
            },
          });
        if (createResult.status !== 200) {
          throw new Error(`Response status is "${createResult.status}"`);
        }
        if (createResult.data.resultCode !== '0000') {
          throw new Error(`ResultCode is "${createResult.data.resultCode}"`);
        }

        const company = {
          id: this.device.companyID,
          name: this.device.companyName,
          alais: this.device.companyAlias,
        };
        this.processing = false;
        this.$emit('refreshList', company, 'company', 1);
      } catch (e) {
        if (e.response.status === 400) {
          alert('입력값을 확인해 주세요.\n(필수항목: 냉장고 이름, 사업자 회사, 사업자 부서)');
        }
        this.processing = false;
        console.error(e);
      }
    },
    cancelUpdate() {
      const company = {
        id: this.device.companyID,
        name: this.device.companyName,
        alais: this.device.companyAlias,
      };
      this.$emit('refreshList', company, 'company');
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/device/DeviceCreate.vue